
import Splide from '@splidejs/splide';
const splideElement = document.querySelector('.splide');
if (splideElement) {
    const splide = new Splide(splideElement, {
        type: 'fade',
        rewind: true,
        autoplay: true,
        interval: 5000,
        speed: 2000,
        arrows: false,
        pagination: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        easing: 'ease-in-out',
    });
    splide.on('move', () => {
        const lastElement = splide.root.querySelector('.splide__slide:last-child picture');
        if (splide.index === 0) {
            lastElement.classList.add('is-prev');
            return;
        }
        if (lastElement.classList.contains('is-prev')) {
            lastElement.classList.remove('is-prev');
        }
    });
    splide.mount();
}
